import React, { Component } from 'react'
import { connect } from 'react-redux'
import { requireAuthentication } from '../helpers/authentication'
import { getUserIsSaving, getCustomUsersAttributes } from '../selectors/users'
import { requestUserCreation, fetchCustomAttributes } from '../thunks/users'
import Forbidden from '../components/Forbidden'
import MustHave from '../containers/MustHave'
import { CreateUser } from '../components/Users'
import Loading from '../components/Loading'

class UserAddContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      customAttributesFetched: false,
    }
  }

  componentDidMount() {
    const { fetchCustomAttributes } = this.props
    fetchCustomAttributes().then((res) => {
      this.setState({ customAttributesFetched: true })
    })
  }

  render() {
    const { customAttributesFetched } = this.state
    if (!customAttributesFetched) {
      return <Loading />
    }

    return (
      <MustHave
        permission="page-user-administration:get"
        fallback={<Forbidden />}
      >
        <CreateUser {...this.props} />
      </MustHave>
    )
  }
}

const mapState = (state) => ({
  isSaving: getUserIsSaving(state),
  customAttributes: getCustomUsersAttributes(state),
})

const mapDispatch = (dispatch) => ({
  createUser: (values) => dispatch(requestUserCreation(values)),
  fetchCustomAttributes: () => dispatch(fetchCustomAttributes()),
})

export default connect(
  mapState,
  mapDispatch,
)(requireAuthentication(UserAddContainer))
